<template>
  <div>
    <b-modal
      @hidden="blShowChange(false)"
      @shown="blShowChange(true)"
      id="ModalListaCenarios"
      size="xl"
      :no-close-on-backdrop="loading"
      :no-close-on-esc="loading"
    >
      <Header titulo="Carregar Cenário" slot="modal-header" :close="closeModal" />
      <div v-if="loading" class="loading-modal-carregar">
        <!-- <div v-if="true" class="loading-modal-carregar"> -->
        <div>
          <LoadingPadraoContainer
            :fraseLoading="
              loadingExcluir
                ? ['Excluindo Cenário', 'Aguarde um momento']
                : ['Carregando Cenário', 'Aguarde um momento']
            "
            delay="5000"
            classe="azul"
            background
          />
        </div>
      </div>
      <div>
        <div class="cenarios-filtro">
          <h3>Filtros:</h3>
          <div class="input-nome">
            <CenarioInput
              tipo="texto"
              maxlength="100"
              :model="nomeCenario"
              placeholder="Nome do cenário"
              @update:model="update => (nomeCenario = update)"
            />
          </div>
          <div class="input-operacao-destinacao">
            <CenarioInput
              desativaTabSelect
              placeholder="Tipo de operação"
              :model="tipoOperacaoModel"
              :options="tipoOperacaoOptions"
              @update:model="update => (tipoOperacaoModel = update)"
              @selected="update => (tipoOperacaoSelec = update)"
            />
          </div>
          <div class="input-operacao-destinacao">
            <CenarioInput
              desativaTabSelect
              placeholder="Destinação"
              :model="destinacaoModel"
              :options="destinacaoOptions"
              @update:model="update => (destinacaoModel = update)"
              @selected="update => (destinacaoSelec = update)"
            />
          </div>
          <BotaoPadrao
            arredondadoEsquerda
            class="botao-limpar-filtros"
            nome="Limpar"
            icone="eraser"
            :click="LimparFiltros"
          />
          <div class="cenarios-contador-wrapper">
            <CounterNcm
              class="cenarios-contador"
              :contadorAtual="this.getCenarios.length"
              :contadorTotal="cenarioTotal"
              tituloTooltipCheio="Limite de cenários cadastrados atingido."
              tituloTooltip="Cenários cadastrados."
            />
          </div>
        </div>

        <div id="modal-cenarios" class="carousel slide" data-ride="carousel">
          <ol v-if="Math.ceil(cenariosFiltrados.length / 5) > 1" class="carousel-indicators">
            <li
              v-for="(_, index) in Math.ceil(cenariosFiltrados.length / 5)"
              :key="index"
              @click="goToPage(index)"
              :class="[page == index ? 'active' : '']"
            ></li>
          </ol>
          <div :class="['carousel-inner']">
            <div v-if="cenariosFiltrados.length > 0">
              <div
                v-for="(_, index2) in Math.ceil(cenariosFiltrados.length / 5)"
                :class="[
                  'carousel-transition',
                  'carousel-item',
                  jumpPage
                    ? page == index2
                      ? 'active'
                      : ''
                    : [activeSlide(index2), activeAnimation(index2)]
                ]"
                :key="index2"
              >
                <div :class="['lista-cenarios']">
                  <button
                    v-for="(cenario, index) in paginacao[index2]"
                    :ref="`card${index2}${index}`"
                    :key="index"
                    :class="['card-new', { selected: cenarioSelected == cenario }]"
                    @click="select(cenario)"
                    @focus="cardFocus(cenario)"
                    @blur="cardBlur"
                    @keydown.right="navegaSelectDireita(index)"
                    @keydown.left="navegaSelectEsquerda(index)"
                    @keydown.up="navegaSelectNextPage()"
                    @keydown.down="navegaSelectPrevPage()"
                  >
                    <div :class="{ 'area-focus': cardOnFocus && cenarioSelected == cenario }"></div>

                    <span
                      v-if="
                        editarTitulo.value &&
                          editarTitulo.index == index &&
                          editarTitulo.index2 == index2
                      "
                      class="title-cenario"
                    >
                      <label>
                        <input
                          maxlength="100"
                          type="text"
                          name="nomeCenario"
                          v-model="cenario.nome_cenario"
                          class="editar-titulo-input"
                          ref="editarTituloInput"
                          @keyup.esc="editaTituloCancela(cenario)"
                          @keyup.enter="
                            desligaBlur();
                            editaTituloConfirma(cenario, index, index2);
                          "
                          @focus="onFocusCenario"
                          @blur="
                            editaBlur(cenario);
                            onBlurCenario();
                          "
                        />
                      </label>
                      <div class="alterar-nome-loading" v-if="atualizaNomeLoading">
                        <font-awesome-icon icon="spinner" spin class="cenario-btn-result-spin" />
                      </div>
                      <div v-else class="alterar-nome-btn">
                        <div
                          v-on:mouseover="desligaBlur"
                          v-on:mouseleave="ligaBlur"
                          @click="editaTituloConfirma(cenario, index, index2)"
                          class="editar-titulo"
                        >
                          <font-awesome-icon v-b-tooltip.hover title="Confirma" icon="check" />
                        </div>
                        <div
                          @click="editaTituloCancela(cenario)"
                          class="editar-titulo editar-titulo-cancela"
                        >
                          <font-awesome-icon v-b-tooltip.hover title="Cancela" icon="times" />
                        </div>
                      </div>
                    </span>
                    <span v-else class="title-cenario">
                      <label
                        class="title-cenario-nome"
                        v-b-tooltip.hover
                        :title="cenario.nome_cenario"
                      >
                        {{ cenario.nome_cenario }}
                      </label>
                      <div
                        class="alterar-nome-loading"
                        v-if="atualizaNomeLoading && editarTitulo.index == index"
                      >
                        <font-awesome-icon icon="spinner" spin class="cenario-btn-result-spin" />
                      </div>
                      <div
                        v-else
                        @click="editaTitulo(cenario, index, index2)"
                        :class="[
                          'editar-titulo',
                          atualizaNomeLoading ? 'editar-titulo-desativa' : ''
                        ]"
                      >
                        <font-awesome-icon v-b-tooltip.hover title="Editar título" icon="edit" />
                      </div>
                    </span>
                    <CardCenario :cenario="cenario" />
                  </button>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="carousel-vazio">
                <span>Nenhum Cenário Salvo foi encontrado.</span>
              </div>
            </div>
          </div>
          <a
            v-if="Math.ceil(cenariosFiltrados.length / 5) > 1"
            class="carousel-control-prev"
            @click="carPrevPage"
            role="button"
            data-slide="prev"
          >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a
            v-if="Math.ceil(cenariosFiltrados.length / 5) > 1"
            class="carousel-control-next"
            @click="carNextPage"
            role="button"
            data-slide="next"
          >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>

      <template slot="modal-footer">
        <BotaoPadrao
          arredondadoEsquerda
          class="botao-padding"
          nome="Cancelar"
          icone="times"
          :desabilita="loading || atualizaNomeLoading"
          :click="closeModal"
        />
        <BotaoPadrao
          arredondadoEsquerda
          class="botao-padding"
          nome="Excluir"
          icone="trash"
          :click="deleteIt"
          :loading="loadingExcluir"
          :desabilita="loading || !cenarioSelected || atualizaNomeLoading"
          cor="vermelho"
        />
        <BotaoPadrao
          arredondadoEsquerda
          class="botao-padding"
          nome="Confirmar"
          icone="check"
          :click="confirm"
          :desabilita="loading || !cenarioSelected || atualizaNomeLoading"
          cor="azul"
        />
      </template>
    </b-modal>

    <ConfirmModal
      icone="trash"
      color="#ad1936"
      :blShow="blShowConfirmModal"
      :labels="confirmModalData"
      :confirmAction="confirmModalConfirm"
      :cancelButton="cancelModalConfirm"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import ModalSlot from "@/components/ModalSlot/ModalSlot.vue";
import ConfirmModal from "@/components/ConfirmModal/ConfirmModal.vue";
import CardCenario from "@/components/CardCenario/CardCenario.vue";
import cenariosMixin from "@/mixins/cenariosMixin";
import Api from "../../../services/api";
import CounterNcm from "@/modules/Pesquisa/components/Head/CounterNcm.vue";
import CenarioInput from "@/components/CenarioInput/CenarioInput.vue";
import Header from "@/components/ModalComponente/Header.vue";
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";

export default {
  name: "ListaCenarios",
  mixins: [cenariosMixin],
  components: {
    ModalSlot,
    ConfirmModal,
    CardCenario,
    BotaoPadrao,
    CounterNcm,
    CenarioInput,
    Header,
    LoadingPadraoContainer
  },
  inject: ["pushAlert"],
  data() {
    return {
      cardOnFocus: false,
      blShow: false,
      bloqueiaKey: true,
      modalBodyFocus: true,
      labels: { title: "Selecione um cenário", message: "" },
      cenarioSelected: null,
      loading: false,
      loadingExcluir: false,
      confirmModalData: { title: "", message: "" },
      blShowConfirmModal: false,
      cenarioDelete: null,
      page: 0,
      slideRight: true,
      jumpPage: false,
      activeTransitionRight: "",
      activeTransitionLeft: "",
      inactiveTransitionRight: "",
      inactiveTransitionLeft: "",
      lastClick: 0,
      lastClickKey: 0,
      lastClickCard: 0,
      delay: 500,
      tipoOperacaoModel: "",
      tipoOperacaoSelec: "",
      tipoOperacao: [
        { label: "Exportação", value: 46 },
        { label: "Importação", value: 41 },
        { label: "Interestadual", value: 40 },
        { label: "Interna", value: 39 }
      ],
      tipoOperacaoOptions: ["Exportação", "Importação", "Interestadual", "Interna"],
      destinacaoModel: "",
      destinacaoSelec: "",
      destinação: [
        { label: "Insumo", value: 19 },
        { label: "Revenda", value: 20 },
        { label: "Sujeita ao ICMS", value: 21 },
        { label: "Sujeita ao ISS", value: 22 },
        { label: "Ativo Imobilizado", value: 24 },
        { label: "Uso ou consumo", value: 26 },
        { label: "Consumo Final", value: 27 }
      ],
      destinacaoOptions: [
        "Insumo",
        "Revenda",
        "Sujeita ao ICMS",
        "Sujeita ao ISS",
        "Ativo Imobilizado",
        "Uso ou consumo",
        "Consumo Final"
      ],
      nomeCenario: "",
      filterOp: "",
      cenarioFilterOp: [],
      filterDes: "",
      cenarioFilterDes: [],
      editarTitulo: { value: false, index: "", index2: "" },
      nomeCenarioEditBackup: "",
      ativaBlur: true,
      alertas: [],
      atualizaNomeLoading: false
    };
  },
  created() {
    window.addEventListener("wheel", this.scrollCenarios, { passive: false });
    document.addEventListener("keyup", this.handleKey);
    setTimeout(() => {
      let card = `card${this.page}0`;
      if (card && this.$refs[card]) {
        this.$refs[card][0].focus();
      }
    }, 100);
  },
  beforeDestroy() {
    window.removeEventListener("wheel", this.scrollCenarios, { passive: false });
    document.removeEventListener("keyup", this.handleKey);
  },
  watch: {
    // tipoOperacaoSelec() {
    //   console.log('deu');
    //   setTimeout(() => {
    //     this.tipoOperacaoModel = this.tipoOperacaoSelec;
    //   }, 1000);
    // },
    nomeCenario() {
      if (!!this.cenariosFiltrados.length) {
        this.select(this.cenariosFiltrados[0]);
      } else {
        this.select(null);
      }
      this.goToPage(0);
    },
    tipoOperacaoSelec() {
      if (!!this.cenariosFiltrados.length) {
        this.select(this.cenariosFiltrados[0]);
      } else {
        this.select(null);
      }
      this.tipoOperacaoModel = this.tipoOperacaoSelec;
      this.goToPage(0);
    },
    destinacaoSelec() {
      if (!!this.cenariosFiltrados.length) {
        this.select(this.cenariosFiltrados[0]);
      } else {
        this.select(null);
      }
      this.destinacaoModel = this.destinacaoSelec;
      this.goToPage(0);
    },
    cenariosFiltrados: {
      deep: true,
      handler() {
        if (this.page > Math.ceil(this.cenariosFiltrados.length / 5) - 1) {
          this.page = Math.ceil(this.cenariosFiltrados.length / 5) - 1;
        }
      }
    },
    blShow: function(newValue) {
      this.$nextTick(() => {
        let card = `card${this.page}0`;
        if (this.$refs[card]) {
          this.$refs[card][0].focus();
        }
      });
      if (Math.ceil(this.getCenarios.length / 5) == 1) {
        this.goToPage(0);
      }
      if (newValue == true) {
        this.search();
        this.bloqueiaKey = true;
        setTimeout(() => {
          this.bloqueiaKey = false;
        }, 300);
        this.goToPage(this.page);
      }
    },
    ncmCenario: function(newValue, oldValue) {
      if (!this.cenarioSelected) {
        return;
      }

      if (newValue && newValue != null && typeof newValue != "undefined") {
        let label = newValue && newValue.label ? newValue.label : "";
        label = newValue[0] && newValue[0].label ? newValue[0].label : label;

        // this.labels.message = "<b>NCM:</b> " + label;
      }
    }
  },
  computed: {
    ...mapGetters("usuario", ["getUsuario"]),
    ...mapGetters("cenario", ["getCenarios", "getFiltros"]),
    ...mapGetters("modal", {
      // blShow: "getModalListaCenarios",
      id: "getIdCenario",
      ncmCenario: "getNcmCenario"
    }),
    cenarioTotal() {
      const total = JSON.parse(localStorage.getItem("assinatura")).qtde_cenario;
      return total;
    },
    cenariosFiltrados() {
      if (this.tipoOperacaoSelec) {
        this.filterOp = this.tipoOperacao.filter(p => p.label == this.tipoOperacaoSelec)[0].value;
        this.cenarioFilterOp = this.getCenarios.filter(p => p.id_local_operacao == this.filterOp);
      } else {
        this.cenarioFilterOp = this.getCenarios;
      }
      if (this.destinacaoSelec) {
        this.filterDes = this.destinação.filter(p => p.label == this.destinacaoSelec)[0].value;
        this.cenarioFilterDesOp = this.cenarioFilterOp.filter(
          p => p.id_destinacao == this.filterDes
        );
      } else {
        this.cenarioFilterDesOp = this.cenarioFilterOp;
      }
      if (this.nomeCenario) {
        this.cenarioFilterDesOpNome = this.cenarioFilterDesOp.filter(p =>
          p.nome_cenario
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .includes(
              this.nomeCenario
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
            )
        );
      } else {
        this.cenarioFilterDesOpNome = this.cenarioFilterDesOp;
      }

      return this.cenarioFilterDesOpNome;
    },
    paginacao() {
      const paginas = [];
      for (let index = 0; index < Math.ceil(this.cenariosFiltrados.length / 5); index++) {
        const pagina = this.cenariosFiltrados.slice(index * 5, index * 5 + 5);
        paginas.push(pagina);
      }
      return paginas;
    }
  },
  methods: {
    ...mapActions("cenario", ["fetchCenarios", "selectCenario", "deleteCenario"]),
    ...mapActions("modal", ["setModalListaCenarios"]),
    cardFocus(cenario) {
      this.cardOnFocus = true;
      this.select(cenario);
    },
    cardBlur() {
      this.cardOnFocus = false;
    },
    blShowChange(bool) {
      this.blShow = bool;
    },
    handleKey(event) {
      if (
        event.key === "Delete" &&
        this.modalBodyFocus &&
        this.blShow &&
        !this.blShowConfirmModal &&
        this.cardOnFocus
      ) {
        this.deleteIt();
      }
      if (
        event.key === "Enter" &&
        this.modalBodyFocus &&
        this.blShow &&
        !this.blShowConfirmModal &&
        this.cardOnFocus
      ) {
        if (this.bloqueiaKey == false) {
          this.confirm();
        }
      }
    },
    closeModal() {
      this.$root.$emit("bv::hide::modal", "ModalListaCenarios");
    },
    navegaSelectDireita(index) {
      if (this.editarTitulo.value) return;
      let cardRef = `card${this.page}${index + 1}`;
      let pageRef = `card${this.page + 1}0`;
      let card = this.$refs[cardRef] ? this.$refs[cardRef][0] : null;
      let page = this.$refs[pageRef] ? this.$refs[pageRef][0] : null;
      let pageZero = this.$refs.card00[0];
      if (!card) {
        if (this.lastClickKey >= Date.now() - 500) {
          return;
        }
        this.lastClickKey = Date.now();
        this.carNextPage();
        setTimeout(() => {
          page ? page.focus() : pageZero.focus();
        }, 200);
      } else {
        if (this.lastClickCard >= Date.now() - 100) {
          return;
        }
        this.lastClickCard = Date.now();
        card.focus();
      }
    },
    navegaSelectEsquerda(index) {
      if (this.editarTitulo.value) return;
      let cardRef = `card${this.page}${index - 1}`;
      let pageRef = `card${this.page - 1}4`;
      let card = index > 0 ? this.$refs[cardRef][0] : null;
      let page = this.$refs[pageRef] ? this.$refs[pageRef][0] : null;
      let maxPage = this.paginacao.length - 1;
      let maxCard = this.paginacao[maxPage].length - 1;
      let cardMax = `card${maxPage}${maxCard}`;
      let pageMax = this.$refs[cardMax][0];
      if (index == 0) {
        if (this.lastClickKey >= Date.now() - 500) {
          return;
        }
        this.lastClickKey = Date.now();
        this.carPrevPage();
        setTimeout(() => {
          page ? page.focus() : pageMax.focus();
        }, 200);
      } else {
        if (this.lastClickCard >= Date.now() - 100) {
          return;
        }
        this.lastClickCard = Date.now();
        card.focus();
      }
    },
    navegaSelectNextPage() {
      if (this.lastClickKey >= Date.now() - this.delay) {
        return;
      }
      this.lastClickKey = Date.now();

      let pageRef = `card${this.page + 1}0`;
      let page = this.$refs[pageRef] ? this.$refs[pageRef][0] : null;
      let pageZero = this.$refs.card00[0];
      this.carNextPage();
      setTimeout(() => {
        if (page) {
          page.focus();
        } else {
          pageZero.focus();
        }
      }, 200);
    },
    navegaSelectPrevPage() {
      if (this.lastClickKey >= Date.now() - this.delay) {
        return;
      }
      this.lastClickKey = Date.now();

      let pageRef = `card${this.page - 1}0`;
      let page = this.$refs[pageRef] ? this.$refs[pageRef][0] : null;
      let maxPage = this.paginacao.length - 1;
      let cardMax = `card${maxPage}0`;
      let pageMax = this.$refs[cardMax][0];

      this.carPrevPage();
      setTimeout(() => {
        if (page) {
          page.focus();
        } else {
          pageMax.focus();
        }
      }, 200);
    },

    onFocusCenario() {
      this.modalBodyFocus = false;
    },
    onBlurCenario() {
      this.modalBodyFocus = true;
    },
    editaBlur(cenario) {
      if (this.ativaBlur) {
        this.editaTituloCancela(cenario);
      }
    },
    desligaBlur() {
      this.ativaBlur = false;
    },
    ligaBlur() {
      this.ativaBlur = true;
    },
    editaTitulo(cenario, index, index2) {
      if (this.atualizaNomeLoading) {
        return;
      }
      this.nomeCenarioEditBackup = cenario.nome_cenario;
      this.editarTitulo.value = true;
      this.editarTitulo.index = index;
      this.editarTitulo.index2 = index2;
      this.$nextTick(() => {
        this.$refs.editarTituloInput[0].select();
      });
    },
    async editaTituloConfirma(cenario, index, index2) {
      if (cenario.nome_cenario == "") {
        this.editaTituloCancela(cenario);
        return;
      }
      this.atualizaNomeLoading = true;
      this.editarTitulo.value = false;
      await new Api()
        .post(`Cenario/alterarNome/${cenario.id}`, {
          nomeCenario: cenario.nome_cenario
        })
        .then(response => {
          if (response.status == true) {
            this.pushAlert("Nome alterado com sucesso", "success");
          } else {
            this.pushAlert("Nome do cenário já foi utilizado", "danger");
            cenario.nome_cenario = this.nomeCenarioEditBackup;
          }
        })
        .catch(err => {});
      this.nomeCenarioEditBackup = cenario.nome_cenario;
      this.editarTitulo.index = index;
      this.editarTitulo.index2 = index2;
      this.ativaBlur = true;
      await new Promise(() => {
        this.atualizaNomeLoading = false;
      });
    },
    editaTituloCancela(cenario) {
      cenario.nome_cenario = this.nomeCenarioEditBackup;
      this.editarTitulo.value = false;
    },
    LimparFiltros() {
      this.nomeCenario = "";
      this.tipoOperacaoSelec = "";
      this.destinacaoSelec = "";
      this.tipoOperacaoModel = "";
      this.destinacaoModel = "";
      this.goToPage(0);
    },
    limpaNomeBusca() {
      this.nomeCenario = "";
    },
    scrollCenarios(event) {
      if (event.deltaY < 0 && this.blShow) {
        event.preventDefault();
        this.navegaSelectPrevPage();
        // this.select(this.paginacao[this.page][0])
      }
      if (event.deltaY > 0 && this.blShow) {
        event.preventDefault();
        this.navegaSelectNextPage();
        // this.select(this.paginacao[this.page][0])
      }
    },
    activeSlide(index) {
      if (this.slideRight) {
        if (this.page == index || this.page == index + 1) {
          return "active";
        }
        return "";
      } else {
        if (this.page == index || this.page == index - 1) {
          return "active";
        }
        return "";
      }
    },
    activeAnimation(index) {
      if (this.slideRight) {
        if (this.page == index) {
          return this.activeTransitionRight;
        }
        return this.inactiveTransitionRight;
      } else {
        if (this.page == index) {
          return this.activeTransitionLeft;
        }
        return this.inactiveTransitionLeft;
      }
    },
    carNextPage() {
      if (Math.ceil(this.cenariosFiltrados.length / 5) <= 1) {
        return;
      }
      // this.select(null);
      if (this.editarTitulo.value) {
        return;
      }
      if (this.lastClick >= Date.now() - this.delay) return;
      else {
        this.lastClick = Date.now();

        this.jumpPage = false;
        this.activeTransitionRight = "active-transition-right";
        this.inactiveTransitionRight = "inactive-transition-right";
        this.slideRight = true;

        if (this.page == Math.ceil(this.cenariosFiltrados.length / 5) - 1) {
          this.page = -1;
        }
        this.page++;
      }
    },
    carPrevPage() {
      if (Math.ceil(this.cenariosFiltrados.length / 5) <= 1) {
        return;
      }
      // this.select(null);
      if (this.editarTitulo.value) {
        return;
      }
      if (this.lastClick >= Date.now() - this.delay) return;
      else {
        this.lastClick = Date.now();

        this.jumpPage = false;
        this.activeTransitionLeft = "active-transition-left";
        this.inactiveTransitionLeft = "inactive-transition-left";
        this.slideRight = false;
        if (this.page == 0) {
          this.page = Math.ceil(this.cenariosFiltrados.length / 5);
        }
        this.page--;
      }
    },
    goToPage(page) {
      if (this.editarTitulo.value) {
        return;
      }
      this.jumpPage = true;
      this.page = page;
    },
    simpleName: function(str) {
      str = str.length > 10 ? str.substring(0, 10) + "..." : str;

      return str.trim();
    },
    search: async function() {
      this.loading = true;
      if (!this.getCenarios || this.getCenarios.length == 0) {
        await this.fetchCenarios();
      }

      this.loading = false;
    },
    select: function(cenario) {
      this.cenarioSelected = cenario;
    },
    confirm() {
      if (!this.cenarioSelected) {
        this.pushAlert("selecione um cenário", "danger");
        return;
      }

      let cenario = this.cenarioSelected;

      this.selectCenario({ ...cenario, idCenario: this.id });
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.$root.$emit("bv::hide::modal", "ModalListaCenarios");
      }, 500);
    },
    cancel: function() {
      this.jumpPage = true;

      this.setModalListaCenarios({ id: null, modal: false, ncm: null });
      this.cenarioSelected = null;
    },
    deleteIt() {
      let cenario = this.cenarioSelected;

      if (!this.cenarioSelected) {
        this.pushAlert("selecione um cenário", "danger");
        return;
      }

      this.confirmModalData = {
        title: "Excluir Cenário",
        message: "Deseja excluir o cenário " + cenario.nome_cenario + "?"
      };
      this.blShowConfirmModal = true;
      this.cenarioDelete = cenario;
    },
    async confirmModalConfirm() {
      let cenarioDelete = this.cenarioDelete;

      if (!cenarioDelete) {
        return;
      }
      this.loading = true;
      this.loadingExcluir = true;
      this.blShowConfirmModal = false;
      await this.deleteCenario(cenarioDelete.id);
      this.cenarioDelete = null;
      this.cenarioSelected = null;
      this.selectCenario(false);
      this.loading = false;
      this.loadingExcluir = false;
    },
    cancelModalConfirm: function() {
      this.blShowConfirmModal = false;
      this.cenarioDelete = null;
    }
  }
};
</script>

<style lang="scss">
@keyframes slideInRight {
  0% {
    transform: translateX(100%);
    filter: blur(0);
  }
  25% {
    filter: blur(0.8px);
  }
  75% {
    filter: blur(0.8px);
  }
  100% {
    transform: translateX(0);
    filter: blur(0);
  }
}
@keyframes slideOutRight {
  0% {
    transform: translateX(0);
    filter: blur(0);
  }
  25% {
    filter: blur(0.8px);
  }
  75% {
    filter: blur(0.8px);
  }

  100% {
    transform: translateX(-100%);
    filter: blur(0);
  }
}
@keyframes slideInLeft {
  0% {
    transform: translateX(-100%);
    filter: blur(0);
  }
  25% {
    filter: blur(0.8px);
  }
  75% {
    filter: blur(0.8px);
  }

  100% {
    transform: translateX(0);
    filter: blur(0);
  }
}
@keyframes slideOutLeft {
  0% {
    transform: translateX(0);
    filter: blur(0);
  }
  25% {
    filter: blur(0.8px);
  }
  75% {
    filter: blur(0.8px);
  }

  100% {
    transform: translateX(100%);
    filter: blur(0);
  }
}
.carousel-control-prev,
.carousel-control-next {
  transition: all 0.2s ease-in-out !important;
  height: 329px;
  background: #d3d3d3;
  width: 30px !important;
  margin: 5px;
  border-radius: 50px;
  box-shadow: 2px 2px 4px #8d8d8da1;
}
.carousel {
  .carousel-indicators {
    li {
      background-color: gray;
    }
    .active {
      background-color: var(--azul4);
    }
  }
}
.carousel-indicators {
  margin: 0 auto -15px auto;
}
.carousel-vazio {
  height: 345px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.lista-cenarios {
  margin-top: 5px;
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  .card-new {
    position: relative;
    width: 193px;
    height: 330px;
    border: 1px var(--azul5) solid;
    box-shadow: var(--sombra1) 4px 4px;
    background: var(--azul4);
    color: var(--branco);
    text-align: center;
    padding: 5px;
    margin: 0 6px 10px 4px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    transition: all 0.1s ease-in-out;
    &:hover {
      text-decoration: none;
      border: 1px var(--azul5) solid;
      background: var(--azul5);
    }
    &.selected {
      border: 1px var(--azul4) solid;
      background: var(--azul2);
    }
    .title-cenario {
      z-index: 2;
      white-space: nowrap;
      width: 100%;
      font-size: 16px;
      height: 30px;
      font-weight: bold;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px var(--branco) solid;
      padding-bottom: 5px;
      margin-bottom: 5px;
      .title-cenario-nome {
        position: relative;
        font-weight: bold;
        font-size: 17px;
        line-height: 16px;
        width: 100%;
        display: flex;
        overflow: hidden;
        background: linear-gradient(to right, var(--branco) 80%, #ffffff00 98%);
        background-clip: text;
        -webkit-text-fill-color: transparent;
        -moz-text-fill-color: transparent;
        height: 18px;
      }
      label {
        font-size: 16px;
        margin: 0;
        padding: 0;
      }
    }
    .editar-titulo {
      margin-left: 0px;
      height: 23px;
      width: 23px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .editar-titulo-desativa {
      color: #ffffff80;
    }
    .editar-titulo-cancela {
      font-size: 19px;
    }
    .resume {
      text-align: left;
      max-width: 150px;
      font-size: 11px;
    }
  }
  .delete-cenario {
    float: right;
    font-size: 12px;
  }
}
.carousel-transition {
  transition: all 0.5s ease-in-out;
}
.active-transition-right {
  animation: slideInRight 0.5s forwards ease-in-out;
}
.inactive-transition-right {
  animation: slideOutRight 0.5s forwards ease-in-out;
}
.active-transition-left {
  animation: slideInLeft 0.5s forwards ease-in-out;
}
.inactive-transition-left {
  animation: slideOutLeft 0.5s forwards ease-in-out;
}
.input-operacao-destinacao {
  min-width: 200px;
  margin-left: 10px;
}
.cenarios-filtro {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 52px;
  padding-bottom: 7px;
  h3 {
    margin: 0;
    line-height: 33px;
    font-family: "Open Sans";
    font-weight: bold;
    color: var(--cinza2);
    font-size: 13px;
    text-transform: uppercase;
  }
}
.limpar-filtros {
  margin-left: 10px;
  height: 29px;
  margin-top: 1px;
}
.input-nome {
  position: relative;
  width: 100%;
  margin-left: 10px;
}
.editar-titulo-input {
  width: 110px;
  background: var(--azul4);
  padding: 0 5px;
  border-radius: 2px;
}
.alterar-nome-btn {
  display: flex;
}
.alterar-nome-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
}
.cenarios-contador-wrapper {
  display: flex;
  justify-content: center;
  min-width: fit-content;
  height: 30px;
}
.cenarios-contador {
  margin: 2px 0 0 5px !important;
}
.botao-limpar-filtros {
  margin: 0 10px;
}
.loading-modal-carregar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--backdrop);
  color: var(--branco);
  z-index: 1000;
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    // width: 100%;
    // font-size: 50px;
  }
}
.area-focus {
  // z-index: -1;
  border-radius: 2px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 1px solid var(--azul4) !important;
}
</style>
